const UserRole = {
  ROLE_ONLY_CURRENT_SCHEDULE: "ROLE_ONLY_CURRENT_LIETANIE",
  ROLE_WRITE_MOVEMENT: "ROLE_WRITE_POHYB"
};

export default UserRole;
